import { PolicyCoverages } from '@models/insuranceLine';

export const defaultDisabledPolicyCoverages: PolicyCoverages = {
  LOIGeneralLiabilityInd: false,
  LOIInlandMarineInd: false,
  LOISexualAbuseMolestationInd: false,
  LOIAccidentInd: false,
  LOIProfessionalLiabilityInd: false,
  LOIPropertyInd: false,
  LOIManagementLiabilityInd: false,
  LOIErrorsAndOmissionsInd: false,
  LOIExcessLiabilityInd: false,
};

export const professionalLiabilityBusinessClasses = [
  'Arboretums',
  'Associations (Non-trade and not including HOA/Condo Associations)',
  'Before & After School Educational Programs',
  'Boys & Girl Clubs',
  'Community Action Programs',
  'Community Centers',
  'Conservation Groups',
  'Counseling Offices',
  'Crisis Centers',
  'Food Banks',
  'Foundations',
  'Gardens',
  'Goodwill',
  'Group Homes for IDD',
  'Head Starts',
  "Homeless Shelters & Battered Person's Shelters",
  'Hospices',
  "Independent Living for IDD's",
  'Job Training/Sheltered Workshops',
  'Libraries',
  'Meals on Wheels',
  'Mental Health Residentials',
  'Nonprofits - Not Otherwise Classified',
  'Performance Art Groups',
  'Senior Centers',
  'Social Service Organizations - Not Otherwise Classified',
  'Substance Abuse - Outpatient Only',
  'United Way',
  'YWCA',
  'I/DD Programs - Non Residential',
  'Mental Health Organizations',
  'Cultural & Arts Organizations',
  'Advocacy Organizations',
  "Family and Children's Services",
  'Private Schools (K-12)',
  'Private Schools - Religious',
  'Charter Schools',
  'Home Healthcare - Companion/Personal Care',
  'Home Healthcare - Skilled Care',
];

export const professionalLiabilityLocations = ['AK', 'CO', 'CT', 'HI', 'KY', 'LA', 'ME', 'MN', 'MS', 'NY', 'TN', 'VT'];
